import React from 'react';
import { Row, Col } from 'reactstrap';
import Dropzone from 'react-dropzone';
import Cropper from 'react-cropper';
import SocialIconsHeader from '../../components/social/SocialIconsHeader';
import DatePicker from "react-datepicker";
import { Prompt } from 'react-router';
import moment from 'moment';
import '../../../node_modules/cropperjs/dist/cropper.css';
import '../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import FailedContentModal from '../../modals/FailedContentModal';
import { MdInfoOutline } from "react-icons/md";
import DisappearNotification from "../../modals/disappearNotification";
import ReactTooltip from 'react-tooltip';
import { Roller } from 'react-awesome-spinners';
import { loaderStyle } from '../../styles/modalStyles';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import { browserCompatibilityCheck } from '../../utils/userAgent';
import { verifyTextContent } from "../../utils/verifyText";
import ApiClient from "../../api/ApiClient";
import { connect } from 'react-redux';
import { updateScore, populateStore, requestFailedModal } from '../../actions';

class ProfileContainer extends React.Component {
    constructor(props) {
        super(props);
        this.apiClient = new ApiClient();
        this.state = {
            userId: '',
            userName: '',
            token: "",
            accountType: this.props.accountType,
            gender: '',
            identity: '',
            dob: '',
            aslLevel: '',
            genAccountMessage: "Generating Your Account!",
            startedAge: '',
            showSpinner: false,
            showInvisibleModal: false,
            homeState: '',
            aboutMe: '',
            openUploadModal: false,
            uploadedFile: null,
            uploadedImgSrc: '',
            originalImgSrc: '',
            cropResult: '',
            profileImg: '',
            profilepicbuttonsEnable: true,
            userLevel: this.props.userLevel,
            userNameError: '',
            errors: {},
            shouldBlockNavigation: false,
            promptMessage: 'Your changes to your profile have not been saved. If you continue, the changes will be lost. Do you want to continue?',
            firstTimeUser: true,
            showFailedContentModal: false,
            profilePicFlagged: false,
            profileImgSizeException: false,
            originalFileSize: 0,
            email: this.props.history.location.state.email,
            firstTimeUser: true,
            token: this.props.history.location.state.urlToken,
            facebook_id: this.props.history.location.state.facebook_id,
            signinProvider: this.props.history.location.state.signinProvider,
            thirdPartyUserid: this.props.history.location.state.thirdPartyUserid, uid: this.props.history.location.state.uid
        }
        this.cropImage = this.cropImage.bind(this);
        this.restoreOriginal = this.restoreOriginal.bind(this);
    }
    inputFieldDisplay = {
        minWidth: "250px",
        margin: "0px 0px 0px 0px",
        height: "36px"
    }

    labelDisplay = {
        marginLeft: "15px",
        fontWeight: "bold",
        marginBottom: "0rem"
    }

    selectFieldDisplay = {
        minWidth: "250px",
        margin: "0px 0px 0px 0px",
        height: "36px"
    }

    profileAboutMe = {
        height: "120px",
        margin: "5px 20px 20px 0px;"
    }

    profileResetPWLink = {
        fontSize: "18px",
        fontWeight: "450",
        textDecoration: "underline",
        marginLeft: "350px",
        color: "#5E1D9F",
        cursor: "pointer"
    }

    linkChangeProfilePic = {
        marginTop: "10px",
        fontWeight: "450",
        textDecoration: "underline",
        color: "#5E1D9F",
        cursor: "pointer"
    }
    requiredFieldCSS = {
        fontSize: "15px",
        color: "#CA1916",
        fontWeight: "500"
    }
    flggedFontSize = {
        fontSize: "13px",
        marginTop: "5px",
        marginBottom: "0px"
    }
    loginMsgStyling = {
        marginTop: "15px",
        fontSize: "18px",
        fontWeight: "bold"
    }
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
            errors: {}
        });
        this.setState({ shouldBlockNavigation: true });
    }

    handleValidation() {
        return true;
        // let errors = {};
        // let formIsValid = true;

        // if (!this.state.userName) {
        //     formIsValid = false;
        //     errors["userName"] = "Username is required";
        // }
        // this.setState({ errors: errors });
        // return formIsValid;
    }

    handleDateChange = (date) => {
        this.setState({ dob: date });
    }

    callSaveProfile = async () => {

        
        let vresponse = await this.apiClient.postJSON(this, "/saveProfile", this.state, false);
        
        if (vresponse && vresponse.status) {
            
            if (vresponse.status === 200) {
                
                this.setState({ shouldBlockNavigation: false });
                return vresponse;
            }
         
        }
        else if (vresponse && vresponse.httpServerError) {
            
            this.setState({ shouldBlockNavigation: false });
            // throw "Something Went Wrong With User Action";
        }
        this.setState({ shouldBlockNavigation: false });
    };


    async componentDidMount() {
        // if (this.props.location.state && this.props.location.state.email) {
        //     await this.setState({email:this.props.location.state.email, 
        //         thirdPartyUserid:this.props.location.state.thirdPartyUserid, uid: this.props.location.state.uid});
        // }
        // else {
        //     await this.setState({email:this.props.email, thirdPartyUserid:this.props.thirdPartyUserid});
        // }
        // // TODO Refactor this whole page, ridiculous
        // if (!this.state.userId) { 
        //     await this.setState({ userId:this.props.userId})
        // }
        //this.loadProfile();
    }

    // async componentWillReceiveProps(props) {
    //     if (this.props.history.location.state && this.props.history.location.state.email) {
    //         let self = this;
    //         
    //         await this.setState({

    //         });
    //     }
    //     // else {
    //     //     await this.setState({ email: this.props.email, thirdPartyUserid: this.props.thirdPartyUserid });
    //     // }
    //     // if (!this.state.userId) {
    //     //     await this.setState({ userId: this.props.userId })
    //     // }
    //     //    this.loadProfile();
    // }

    componentDidUpdate = () => {
        if (this.state.shouldBlockNavigation) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = undefined
        }
    }

    // loadProfile = () => {
    //     if (this.state.thirdPartyUserid !== undefined) {
    //         this.getJSON(this,"loadProfile?thirdPartyUserId=" + this.state.thirdPartyUserid)
    //             .then((res) => {
    //   if (res && res.status) {
    //                 if (res.data.profile !== null) {
    //                     this.setState({
    //                         gender: res.data.profile.gender,
    //                         identity: res.data.profile.identity,
    //                         userName: res.data.profile.userName,
    //                         dob: res.data.profile.birthday != undefined ? new Date(res.data.profile.birthday) : '',
    //                         aslLevel: res.data.profile.aslLevel,
    //                         startedAge: res.data.profile.startedAge,
    //                         homeState: res.data.profile.homeState,
    //                         aboutMe: res.data.profile.about,
    //                         profileImg: res.data.profile.img,
    //                         profilePicFlagged: res.data.profile.isFlagged
    //                     });
    //                     this.setState({ shouldBlockNavigation: false });
    //                 } else {
    //                     this.setState({ shouldBlockNavigation: true });
    //                 }

    // }
    // else if (res && res.httpServerError) {
    //     // throw "Something Went Wrong"
    // }
    //             })
    //     }
    // }

    // Actual User Registration
    registerUser = async () => {
        // Set user device and browser
        try {

            const { isCompatible, browser, isMobile, isTablet, userAgent } = browserCompatibilityCheck();
            let self= this

            await self.setState({ browser, isMobile, isTablet, userAgent, loginConsentType: self.props.history.location.state.loginConsentType })
            
            let vresponse = await this.apiClient.postJSON(this, "/registerThirdParty", self.state, false);
            
            if (vresponse && vresponse.status) {

                if (vresponse.status == 200) {
                    return vresponse;
                }
                
            }
            else if (vresponse && vresponse.httpServerError) {
                this.setState({ shouldBlockNavigation: false });
                // throw "Something Went Wrong With User Action";
            }
        }
        catch (err) {
            this.setState({ shouldBlockNavigation: false });
        }
    };

    generateJWT = async (email, signinType, access_token) => {
        const jwt = await this.apiClient.getJSON(null, "/getUser/requestSignedToken?jwtToken=" + this.props.history.location.state.oldJWTToken + "&signinType=" + signinType + "&email=" + email + "&access_token=" + access_token);
        if (jwt) {
            return jwt.data.jwtToken;
        }
    }

    // USER SIGNUP
    saveProfile = async (event) => {

        let self = this;
        this.setState({ showSpinner: true });
        let errors = {};
        event.preventDefault();
        if (this.handleValidation()) {
            let isTextFlagged2 = false;
            // let isTextFlagged2 = await verifyTextContent(this.apiClient, this.state.userName, this, "usernameMarker");
            if (isTextFlagged2) {
                this.setState({ showSpinner: false });
                this.setState({ aboutMarker: false });
                return;
            }


            if (this.state.aboutMe) {
                let isTextFlagged = false;
                //let isTextFlagged = await verifyTextContent(this.apiClient, this.state.aboutMe, this, "aboutMarker");
                if (isTextFlagged) {
                    this.setState({ showSpinner: false });
                    this.setState({ usernameMarker: false });
                    return;
                }
            }
            else {
                this.setState({ cvsTextProcessing: false });
            }
            
            const registerUserRes = await this.registerUser();

            if (registerUserRes && registerUserRes.status) {
                if (registerUserRes.status === 200) {
                    await this.setState({ userId: registerUserRes.userid });
                    const saveProfileRes = await this.callSaveProfile(registerUserRes.userid);
                    
                    if (registerUserRes && saveProfileRes.status) {
                        
                        if (saveProfileRes.status === 200) {
                            
                            // Accounts generated, login now
                            const jwtToken = await this.generateJWT(this.props.history.location.state.email, this.props.history.location.state.signinType,
                                this.props.history.location.state.access_token);
                            localStorage.setItem("jwtToken", jwtToken);

                            this.props.history.push({
                                pathname: '/',
                                state: {
                                    isNewAccount: true
                                }
                            });
                        }
                    }
                }
            }
        }

        this.setState({ showSpinner: false });
    }

    updateProfileImage = (event) => {
        event.preventDefault();
        this.state.openUploadModal = false;
        this.setState({ profileImg: this.state.uploadedImgSrc });
    }
    _crop() {
        // image in dataUrl
    }
    onImageDrop(files) {
        this.setState({
            uploadedFile: files[0],
            profilepicbuttonsEnable: !(files.length > 0),
            originalFileSize: Math.round(files[0].size / (1024 * 1024))
        });
        if (files[0].size >= 4000000) {
            this.setState({ profileImgSizeException: true });
        } else {
            this.setState({ profileImgSizeException: false });
        }
        var reader = new FileReader();
        var url = reader.readAsDataURL(files[0]);
        reader.onloadend = function (e) {
            this.setState({
                uploadedImgSrc: reader.result,
                originalImgSrc: reader.result
            })
        }.bind(this);
    };

    toggleUploadPopup = (event) => {
        event.preventDefault();
        this.setState(prevState => ({
            openUploadModal: !prevState.openUploadModal
        }));
    }
    cropImage() {
        if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
            return;
        }
        this.setState({
            uploadedImgSrc: this.cropper.getCroppedCanvas().toDataURL(),
        });
    }
    restoreOriginal() {
        this.setState({
            uploadedImgSrc: this.state.originalImgSrc
        });
    }

    notify = () => {
        this.setState({ showSpinner: false })
        this.setState({ showInvisibleModal: true })
    }

    render() {
        document.title = 'Profile - The ASL Data Community';
        if (this.props.history.location.state.acceptedConsent === true) {
            const profileImage = this.state.uploadedImgSrc !== "" ? this.state.uploadedImgSrc : this.state.profileImg;
            const flaggedMsgContent = <p style={this.flggedFontSize}><i><b style={{ color: "#E20C0C" }}>WARNING:</b> This profile pic has been flagged and we are in the process of reviewing it.</i></p>;
            const sizeExceptionContent = <p style={this.flggedFontSize}><i style={{ color: "red" }}><b>Error:</b> The uploaded image size is {this.state.originalFileSize} MB. Please upload an image less than <b>4 MB</b></i></p>;
            return (
                <React.Fragment>
                    <DisappearNotification isTransparent={false} text={this.state.verificationStateText} symbol="processing" showInvisibleModal={this.state.cvsTextProcessing}></DisappearNotification>
                    {(this.state.showSpinner && !this.state.hideGenAccount) &&

                        <Row>
                            <Col xs="12">
                                <div style={loaderStyle}>
                                    <Loader
                                        type="ThreeDots"
                                        color="#00BFFF"
                                        height={100}
                                        width={100}
                                    />
                                    {this.state.genAccountMessage}
                                </div>
                            </Col>
                        </Row>

                    }
                    {!this.state.showSpinner &&
                        <div className="registration-form-background">

                            <div className="registration-form-cont">
                                <Prompt
                                    when={this.state.shouldBlockNavigation}
                                    message={this.state.promptMessage}
                                />
                                <div role="main">
                                    <div>
                                        <h1 className="pt-2 pb-1">Register</h1>
                                    </div>
                                    <form onSubmit={this.saveProfile}>






                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will be visible to other users.">Username<span className="requiredTextColor">*</span></p>
                                                <span aria-live="assertive" style={this.requiredFieldCSS}>{this.state.errors["userName"]}</span>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data">
                                                <input style={this.inputFieldDisplay}
                                                    id="userNameInput"
                                                    type="text"
                                                    name="userName"
                                                    className="profile-input"
                                                    //placeholder="Enter name"
                                                    value={this.state.userName}
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                                {this.state.usernameMarker && <span className="margin-top" style={{ color: "red" }} aria-describedby="aboutMe"><i>Please select an appropriate username.</i></span>}
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will NOT be visible to other users.">Email</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data">
                                                <input style={this.inputFieldDisplay}
                                                    id="emailInput"
                                                    type="text"
                                                    name="email"
                                                    className="profile-display-only"
                                                    //placeholder="Enter email"
                                                    value={this.state.email}
                                                    onChange={this.handleInputChange}
                                                    disabled
                                                    required
                                                />
                                            </div>
                                        </div>




                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will be visible to other users.">About</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data">
                                                <span className="margin-top" aria-describedby="aboutMe"><i>Tell us a little about yourself (Limit 500 characters)</i></span>

                                                <textarea className="profile-input" id="aboutMe" style={this.profileAboutMe} name="aboutMe" value={this.state.aboutMe} onChange={this.handleInputChange} maxLength="500"></textarea>
                                                {this.state.aboutMarker && <span className="margin-top" style={{ color: "red" }} aria-describedby="aboutMe"><i>Please select appropriate about me content above.</i></span>}
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will be visible to other users.">Gender</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data">
                                                <select className="profile-input" id="genderCombobox" style={this.selectFieldDisplay} name="gender" value={this.state.gender} onChange={this.handleInputChange} >
                                                    <option value="">Please Select</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                    <option value="PNTD">Prefer not to disclose</option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will NOT be visible to other users, but your age in years will be visible to other users.">Age</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data" style={{ marginLeft: "-15px" }}>

                                                <DatePicker className="profile-input"
                                                    // disabled={!this.state.userLevel.profile}
                                                    id="birthdayDate"
                                                    name="dob"
                                                    selected={this.state.dob}
                                                    placeholderText="MM/DD/YYYY"
                                                    onSelect={this.handleDateChange} required />
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will NOT be visible to other users, but may help advance research.">How do you identify?</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data" >
                                                <select className="profile-input" id="identifyCombobox" style={this.selectFieldDisplay} name="identity" value={this.state.identity} onChange={this.handleInputChange} >
                                                    <option value="">Please Select</option>
                                                    <option value="DEAF">Deaf</option>
                                                    <option value="HOH">Hard-of-Hearing</option>
                                                    <option value="HEAR">Hearing</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will be visible to other users">ASL Level</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data" >
                                                <select className="profile-input" id="aslLevelCombo" name="aslLevel" style={this.selectFieldDisplay} value={this.state.aslLevel} onChange={this.handleInputChange} >
                                                    <option value="">Please Select</option>
                                                    <option value="1">1 - I do not use ASL</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7 - Fluent</option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will NOT be visible to other users, but may help advance research.">Age started learning ASL</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data" >
                                                <input className="profile-input" style={this.inputFieldDisplay}
                                                    id="ageInput"
                                                    type="text"
                                                    name="startedAge"
                                                    //placeholder="Enter Age When Started"
                                                    value={this.state.startedAge}
                                                    onChange={this.handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>


                                        <div className="profile-row">
                                            <div className="profile-label">
                                                <p data-tip="This field will be visible to other users.">Home State</p>
                                                <ReactTooltip />
                                            </div>
                                            <div className="profile-data" >
                                                <select className="profile-input" id="homeStateCombo" name="homeState" style={this.selectFieldDisplay} value={this.state.homeState} onChange={this.handleInputChange} >
                                                    <option value="">Please Select</option>
                                                    <option value="AL">Alabama</option>
                                                    <option value="AL">Alaska</option>
                                                    <option value="AZ">Arizona</option>
                                                    <option value="AR">Arkansas</option>
                                                    <option value="CA">California</option>
                                                    <option value="CO">Colorado</option>
                                                    <option value="CT">Connecticut</option>
                                                    <option value="DE">Delaware</option>
                                                    <option value="FL">Florida</option>
                                                    <option value="GA">Georgia</option>
                                                    <option value="HI">Hawaii</option>
                                                    <option value="ID">Idaho</option>
                                                    <option value="IL">Illinois</option>
                                                    <option value="IN">Indiana</option>
                                                    <option value="IA">Iowa</option>
                                                    <option value="KS">Kansas</option>
                                                    <option value="KY">Kentucky</option>
                                                    <option value="LA">Louisiana</option>
                                                    <option value="ME">Maine</option>
                                                    <option value="MD">Maryland</option>
                                                    <option value="MA">Massachusetts</option>
                                                    <option value="MI">Michigan</option>
                                                    <option value="MN">Minnesota</option>
                                                    <option value="MS">Mississippi</option>
                                                    <option value="MO">Missouri</option>
                                                    <option value="MT">Montana</option>
                                                    <option value="NE">Nebraska</option>
                                                    <option value="NV">Nevada</option>
                                                    <option value="NH">New Hampshire</option>
                                                    <option value="NJ">New Jersey</option>
                                                    <option value="NM">New Mexico</option>
                                                    <option value="NY">New York</option>
                                                    <option value="NC">North Carolina</option>
                                                    <option value="ND">North Dakota</option>
                                                    <option value="OH">Ohio</option>
                                                    <option value="OK">Oklahoma</option>
                                                    <option value="OR">Oregon</option>
                                                    <option value="PA">Pennsylvania</option>
                                                    <option value="RI">Rhode Island</option>
                                                    <option value="SC">South Carolina</option>
                                                    <option value="SD">South Dakota</option>
                                                    <option value="TN">Tennessee</option>
                                                    <option value="TX">Texas</option>
                                                    <option value="UT">Utah</option>
                                                    <option value="VT">Vermont</option>
                                                    <option value="VA">Virginia</option>
                                                    <option value="WA">Washington</option>
                                                    <option value="WV">West Virginia</option>
                                                    <option value="WI">Wisconsin</option>
                                                    <option value="WY">Wyoming</option>
                                                </select>
                                            </div>
                                        </div>


                                        <div style={{ marginTop: "20px" }}><p > <span className="requiredTextColor">*</span> Means required</p></div>
                                        <div style={{ textAlign: "center" }}>
                                            <svg className="save-btn-reg" onClick={this.saveProfile} width="92" height="64" viewBox="0 0 92 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_d)">
                                                    <rect x="10.5" y="5" width="71" height="44" rx="22" fill="#CCCCCC" />
                                                    <path d="M31.313 32.5825V30.7881C31.4741 30.9346 31.6646 31.0664 31.8843 31.1836C32.1089 31.3008 32.3457 31.4009 32.5947 31.4839C32.8438 31.562 33.0928 31.623 33.3418 31.667C33.5908 31.7109 33.8203 31.7329 34.0303 31.7329C34.7627 31.7329 35.3071 31.6108 35.6636 31.3667C36.0249 31.1226 36.2056 30.7686 36.2056 30.3047C36.2056 30.0557 36.1445 29.8408 36.0225 29.6602C35.9053 29.4746 35.7393 29.3062 35.5244 29.1548C35.3096 29.0034 35.0557 28.8594 34.7627 28.7227C34.4746 28.5811 34.1646 28.4346 33.8325 28.2832C33.4761 28.0928 33.144 27.8999 32.8364 27.7046C32.5288 27.5093 32.2603 27.2944 32.0308 27.0601C31.8062 26.8208 31.6279 26.5522 31.4961 26.2544C31.3691 25.9565 31.3057 25.6074 31.3057 25.207C31.3057 24.7139 31.4155 24.2866 31.6353 23.9253C31.8599 23.5591 32.1528 23.2588 32.5142 23.0244C32.8804 22.7852 33.2954 22.6094 33.7593 22.4971C34.2231 22.3799 34.6968 22.3213 35.1802 22.3213C36.2788 22.3213 37.0796 22.4458 37.5825 22.6948V24.416C36.9868 23.9863 36.2202 23.7715 35.2827 23.7715C35.0239 23.7715 34.7651 23.7959 34.5063 23.8447C34.2524 23.8936 34.0229 23.9741 33.8179 24.0864C33.6177 24.1987 33.4541 24.3428 33.3271 24.5186C33.2002 24.6943 33.1367 24.9067 33.1367 25.1558C33.1367 25.3901 33.1855 25.5928 33.2832 25.7637C33.3809 25.9346 33.5225 26.0908 33.708 26.2324C33.8984 26.374 34.1279 26.5132 34.3965 26.6499C34.6699 26.7817 34.9849 26.9258 35.3413 27.082C35.7075 27.2725 36.0518 27.4727 36.374 27.6826C36.7012 27.8926 36.9868 28.1245 37.231 28.3784C37.48 28.6323 37.6753 28.9155 37.8169 29.228C37.9634 29.5356 38.0366 29.8872 38.0366 30.2827C38.0366 30.8149 37.9292 31.2642 37.7144 31.6304C37.4995 31.9966 37.209 32.2944 36.8428 32.5239C36.4814 32.7534 36.064 32.9194 35.5903 33.022C35.1167 33.1245 34.6162 33.1758 34.0889 33.1758C33.9131 33.1758 33.6958 33.1611 33.437 33.1318C33.1831 33.1074 32.9219 33.0684 32.6533 33.0146C32.3848 32.9658 32.1309 32.9048 31.8916 32.8315C31.6523 32.7583 31.4595 32.6753 31.313 32.5825ZM45.2966 33H43.6487V31.8281H43.6194C43.1018 32.7266 42.3425 33.1758 41.3415 33.1758C40.6042 33.1758 40.0256 32.9756 39.6057 32.5752C39.1907 32.1748 38.9831 31.645 38.9831 30.9858C38.9831 29.5698 39.7986 28.7446 41.4294 28.5103L43.656 28.1953C43.656 27.126 43.1482 26.5913 42.1326 26.5913C41.239 26.5913 40.4333 26.8989 39.7156 27.5142V26.0273C40.5066 25.5586 41.4197 25.3242 42.4548 25.3242C44.3494 25.3242 45.2966 26.2568 45.2966 28.1221V33ZM43.656 29.3159L42.0813 29.5356C41.593 29.5991 41.2244 29.7188 40.9753 29.8945C40.7312 30.0654 40.6091 30.3682 40.6091 30.8027C40.6091 31.1201 40.7214 31.3813 40.946 31.5864C41.1755 31.7866 41.4807 31.8867 41.8616 31.8867C42.3791 31.8867 42.8064 31.7061 43.1433 31.3447C43.4851 30.9785 43.656 30.5195 43.656 29.9678V29.3159ZM53.5967 25.5L50.6963 33H48.8579L46.0967 25.5H47.9424L49.605 30.7441C49.7319 31.1299 49.81 31.4668 49.8393 31.7549H49.8613C49.9053 31.3936 49.9736 31.0664 50.0664 30.7734L51.8096 25.5H53.5967ZM60.7468 29.7114H55.6345C55.654 30.4048 55.8664 30.9395 56.2717 31.3154C56.6819 31.6914 57.2434 31.8794 57.9563 31.8794C58.7571 31.8794 59.4919 31.6401 60.1609 31.1616V32.5312C59.4773 32.9609 58.5739 33.1758 57.4509 33.1758C56.3474 33.1758 55.4807 32.8364 54.8508 32.1577C54.2258 31.4741 53.9133 30.5146 53.9133 29.2793C53.9133 28.1123 54.2575 27.1626 54.946 26.4302C55.6394 25.6929 56.4988 25.3242 57.5241 25.3242C58.5495 25.3242 59.343 25.6538 59.9045 26.313C60.466 26.9722 60.7468 27.8877 60.7468 29.0596V29.7114ZM59.1062 28.5103C59.1013 27.8999 58.9572 27.4263 58.674 27.0894C58.3908 26.7476 58.0002 26.5767 57.5022 26.5767C57.0139 26.5767 56.5988 26.7549 56.2571 27.1113C55.9201 27.4678 55.7126 27.9341 55.6345 28.5103H59.1062Z" fill="white" />
                                                </g>
                                                <defs>
                                                    <filter id="filter0_d" x="0.5" y="0" width="91" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                        <feOffset dy="5" />
                                                        <feGaussianBlur stdDeviation="5" />
                                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                    </filter>
                                                </defs>
                                            </svg>
                                        </div>


                                    </form>
                                    {this.state.showFailedContentModal && <FailedContentModal />}
                                    <Modal width="500" isOpen={this.state.openUploadModal} toggle={this.toggleUploadPopup} className="modal-lg">
                                        <ModalHeader toggle={this.toggleUploadPopup}>UPLOAD IMAGE</ModalHeader>
                                        <ModalBody>
                                            <Dropzone
                                                onDrop={this.onImageDrop.bind(this)}
                                                accept="image/*"
                                                multiple={false}>
                                                {({ getRootProps, getInputProps }) => {
                                                    return (
                                                        <div
                                                            {...getRootProps()}
                                                        >
                                                            <input {...getInputProps()} />
                                                            {
                                                                <p style={this.linkChangeProfilePic}>Click here to select the files to upload</p>
                                                            }
                                                        </div>
                                                    )
                                                }}
                                            </Dropzone>
                                            {/* <div className="scroll-content">
                                <input type="file" id="photo" onChange={this.onImageDrop} />
                            </div> */}
                                            <Cropper
                                                ref={cropper => { this.cropper = cropper; }}
                                                src={this.state.uploadedImgSrc}
                                                style={{ height: 400, width: '100%', margin: '10' }}
                                                // Cropper.js options
                                                aspectRatio={1 / 1}
                                                guides={false}
                                                crop={this._crop.bind(this)} />
                                            <button onClick={this.cropImage} style={{ float: 'right' }} disabled={this.state.profilepicbuttonsEnable}>
                                                Crop Image
                                            </button>
                                            <button onClick={this.restoreOriginal} style={{ float: 'right' }} disabled={this.state.profilepicbuttonsEnable}>
                                                Original
                                            </button>
                                            {/* <button onClick={this.updateProfileImage} style={{ float: 'right' }}>
                    Upload
                </button> */}
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={this.updateProfileImage}>Save Image</Button>{' '}
                                            <Button color="secondary" onClick={this.toggleUploadPopup}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    }
                </React.Fragment>
            )
        } else {
            return (<div role="main"><p style={this.loginMsgStyling}>Please <a href="tpLogin">login or create an account</a></p></div>)
        }
    }
}




const mapDispatchToProps = (dispatch) => ({
    updateScore,
    populateStore,
    requestFailedModal,
    dispatch
});

const Profile = connect(

    mapDispatchToProps
)(ProfileContainer);


export default Profile